<template>
  <div v-show="showProductModal" class="modal-mask" transition="modal">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header">
          <slot name="header">Класс</slot>
        </div>

        <div class="modal-body">
          <div class="form-group">
            <label>Наименование</label>
            <input type="text" class="form-control" v-model="product.ru_title"/>
          </div>
          <div class="form-group">
            <label>Код</label>
            <input type="text" class="form-control" v-model="product.code"/>
          </div>
          <div class="form-group">
            <label>Единица измерения</label>
            <select class="form-control" v-model="product.unit_id">
              <option v-for="(unit, index) in units" :key="index" :value="unit.id">{{ unit.title }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Тип</label>
            <select class="form-control" v-model="product.type">
              <option value="0">Не определен</option>
              <option value="1">Товар</option>
              <option value="2">Работа</option>
              <option value="3">Услуга</option>
            </select>
          </div>
        </div>

        <div class="modal-footer">
          <slot name="footer">
            <button class="modal-button btn btn-danger" @click="updateTab('update',false)">Закрыть</button>
            <button class="modal-button btn btn-success" @click="productStore()">Добавить</button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {POST} from "@/shared/api";

export default {
  props: {
    currentChoosenNode: {
      title: null,
      code: null
    },
    showProductModal: false,
    product: {},
    units: [],
  },
  data() {
    return {}
  },
  methods: {
    updateTab(event = 'update', spec) {
      this.$emit(event, spec);
      // console.log(this.specification.fields);
    },
    productStore() {
      POST(this.product, "/product", this).then(response => {
        this.clearProduct();
        this.updateTab('update', {state:"success"});
      });
    },
    updateProductData(){
      if (this.currentChoosenNode !== null){
        this.product.ru_title = this.currentChoosenNode.title
        this.product.code = this.currentChoosenNode.code
        this.product.unit_id = this.units[0]['id']
      }
    },
    clearProduct() {
      this.product.ru_title = null;
      this.product.version = null;
      this.product.unit = null;
      this.product.code = null;
      this.product.category_id = null;
    },
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
